import { Flex, Heading, Text } from "@chakra-ui/react";
import { Briefcase } from "lucide-react";

interface JobImagePlaceholderProps {
  title: string;
  companyName?: string;
  color: string;
  className?: string;
}

/**
 * Renders a styled placeholder when a job has no image.
 * Displays the job title (and optional company name) over a gradient background
 * derived from the embed theme color.
 */
const JobImagePlaceholder = ({ title, companyName, color, className = "" }: JobImagePlaceholderProps) => {
  return (
    <Flex
      className={`w-full h-full items-center justify-center flex-col gap-3 px-6 text-center ${className}`}
      style={{
        background: `linear-gradient(135deg, ${color}22 0%, ${color}66 100%)`,
      }}
    >
      <Briefcase size={32} color={color} strokeWidth={1.5} />
      {companyName && (
        <Text fontSize="sm" fontWeight="semibold" color="gray.500" letterSpacing="wide" textTransform="uppercase">
          {companyName}
        </Text>
      )}
      <Heading size="md" color="gray.700" noOfLines={2}>
        {title}
      </Heading>
    </Flex>
  );
};

export { JobImagePlaceholder };
